import styled from "styled-components"

export const RightArrowButtonStyle = styled.button`
  border: none;
  background-color: transparent;
  &:hover {
    cursor: pointer;
  }
`